import { RequirementNote, } from "./ursOfferSlice";
import { Check, Clear } from "@mui/icons-material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Localized } from "@fluent/react";
import { Box, Typography } from "@mui/material";

export const NoteLabel = ({ note }: { note: RequirementNote | null }) => {
    if (note === null) {
        return null
    }

    switch (note) {
        case "F":
            return <>
                <Check fontSize="small" color='success' />

            </>

        case "U":
            return <>
                <Clear fontSize="small" color='error' />

            </>
        case "D":
            return <>
                <QuestionMarkIcon fontSize="small" color='warning' />

            </>
        default:
            return <span>{note}</span>
    }
}

export const NoteLabelWithText = ({ note }: { note: RequirementNote }) => {
    if (note === null) {
        return null
    }

    switch (note) {
        case "F":
            return (
                <Box display="flex" alignItems="center" gap={1}>
                    <Check fontSize="small" color="success" />
                    <Typography variant="body2">
                        <Localized id="urs-offer-req-f">Spełnia</Localized>
                    </Typography>
                </Box>
            );
        case "U":
            return (
                <Box display="flex" alignItems="center" gap={1}>
                    <Clear fontSize="small" color='error' />
                    <Localized id='urs-offer-req-u'>Nie spełnia</Localized>
                </Box>
            );
        case "D":
            return (
                <Box display="flex" alignItems="center" gap={1}>
                    <QuestionMarkIcon fontSize="small" color='warning' />
                    <Localized id='urs-offer-req-d'>Do oceny</Localized>
                </Box>
            );
        default:
            return <span>{note}</span>
    }
}
